import { createContext, useContext } from "react";

import useScimWizard from "../hooks/useScimWizard";

const ScimWizardContext = createContext(null);

export const useScimWizardContext = () => {
	const context = useContext(ScimWizardContext);
	if (!context) {
		throw new Error("useScimWizardContext must be used within a ScimWizardProvider");
	}
	return context;
};

export const ScimWizardProvider = ({ children, editedId }) => {
	const scimWizard = useScimWizard(editedId);
	return (
		<ScimWizardContext.Provider value={scimWizard}>
			{children}
		</ScimWizardContext.Provider>
	);
};